import React, {useEffect, useRef, useState} from 'react';
import Box from "@mui/material/Box";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import CustomerReviewContainer from "./CustomerReviewContainer";
import { contentTexts } from "../ContentText";
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {useMediaQuery, useTheme} from "@mui/material";

function CustomerPage(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const timerRef = useRef(null);
    const [sliderRef, instanceRef] = useKeenSlider({
        loop: true,
        duration: 1000,
        slideChanged(s) {
            // Optional: handle active slide
        },
        drag: false,
        created() {
            if ((!isMobile||props.visibleButtons) && instanceRef.current) {
                instanceRef.current.update();
            }
        },
    });



    const divRef = useRef(null);
    const nextSlide = () => instanceRef.current?.next();
    const prevSlide = () => instanceRef.current?.prev();

    const _handleClick = e => {
        if (!isMobile)
            return;
        const divWidth = divRef.current.getBoundingClientRect().width;
        const halfDivWidth = divWidth / 2;
        const mouseXPos = e.nativeEvent.offsetX;

        if (mouseXPos <= halfDivWidth) {
            prevSlide()
        } else {
            nextSlide()
        }
    };


    // 🕒 Start auto sliding
    const startAutoPlay = () => {
        clearInterval(timerRef.current);

        timerRef.current = setInterval(() => {
            nextSlide();
        }, 15000); //SAPPER HIER ÄNDERN FÜR
    };

    // ✋ Pause on hover/touch
    const stopAutoPlay = () => {

        clearInterval(timerRef.current);
    };

    useEffect(() => {
        startAutoPlay()
        return () => clearInterval(timerRef.current); // Clean up on unmount
    }, []);
    return (
        <Box ref={props.refs} sx={{ width: '100%',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"

        }}>
            <TopTitle>{contentTexts.customerTitle}</TopTitle>
            <SubTitle>{contentTexts.customerSubtitle}</SubTitle>

            <Box ref={divRef}
                 onClick={_handleClick}
                 sx={{
                position: 'relative',
                width:"100%",
                paddingTop:"24px"

            }}
                 onMouseEnter={stopAutoPlay}
                 onMouseLeave={startAutoPlay}
                 onTouchStart={stopAutoPlay}
                 onTouchEnd={startAutoPlay}
            >
                <Box ref={sliderRef} className="keen-slider" >
                    {contentTexts.customerReviews.map((value, index) => (
                        <Box key={index} className="keen-slider__slide">
                            <CustomerReviewContainer {...value} />
                        </Box>
                    ))}
                </Box>

                {(!isMobile||props.visibleButtons) && (
                    <>
                        <IconButton
                            aria-label="Previous Slide"
                            onClick={prevSlide}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: 0,
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                            }}
                        >
                            <NavigateBeforeIcon />
                        </IconButton>
                        <IconButton
                            aria-label="Next Slide"

                            onClick={nextSlide}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                right: 0,
                                transform: 'translateY(-50%)',
                                zIndex: 2,
                            }}
                        >
                            <NavigateNextIcon />
                        </IconButton>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default CustomerPage;

